import type { ReactNode } from "react";
import { ArrowClockwiseIcon, CircleNotchIcon, WarningOctagonIcon } from "@phosphor-icons/react";

export function Spinner({ size = 16 }: { size?: number }) {
  return <CircleNotchIcon size={size} className="spinner" aria-hidden="true" />;
}

export function Loading({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="loading-line" role="status">
      <Spinner />
      <span>{label}</span>
    </div>
  );
}

export function EmptyState({ title, children, action }: { title: string; children?: ReactNode; action?: ReactNode }) {
  return (
    <div className="state">
      <p className="state__title">{title}</p>
      {children ? <div className="state__body">{children}</div> : null}
      {action}
    </div>
  );
}

export function ErrorState({ title = "Could not load", message, onRetry }: { title?: string; message: string; onRetry?: () => void }) {
  return (
    <div className="state state--error" role="alert">
      <p className="state__title">
        <WarningOctagonIcon size={16} aria-hidden="true" style={{ display: "inline", verticalAlign: "-3px", marginRight: 6 }} />
        {title}
      </p>
      <p className="state__body">{message}</p>
      {onRetry ? (
        <button type="button" className="btn" onClick={onRetry}>
          <ArrowClockwiseIcon size={16} aria-hidden="true" />
          Try again
        </button>
      ) : null}
    </div>
  );
}

export function FormError({ id, message }: { id?: string; message: string | null }) {
  if (!message) return null;
  return (
    <div className="form-error" role="alert" id={id} tabIndex={-1}>
      <WarningOctagonIcon size={16} aria-hidden="true" />
      <p>{message}</p>
    </div>
  );
}
